module.exports = __webpack_public_path__ + "img/Insurance-needs.9a96645a.svg";